const e = {
  "skeleton-container": "_skeleton-container_4jgy7_1"
};
export {
  e as default
};
//# sourceMappingURL=index.es822.js.map
